module.exports = __webpack_public_path__ + "static/media/mobilebackground.60bf2ec8.png";